import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import stylePrem from '../css/backgrounds/primResidency.module.css';
import '../css/AllServices.css'; // استخدام نفس ملف الأنيميشن

function PremiumResidency() {
    const serviceRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        serviceRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            serviceRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    const addToRefs = (el, index) => {
        if (el && !serviceRefs.current.includes(el)) {
            serviceRefs.current[index] = el;
        }
    };

    return (
        <>
        <head style={{all:'initial'}}>
                <title>خطوات التقديم على الإقامة المميزة</title>
                <meta name="description" content="خطوات التقديم على الإقامة المميزة"/>
                <meta name="keywords" content="الفرق بين الإقامة العادية والإقامة المميزة , متطلبات ترخيص استثماري للأجانب 2025" />
                <script>
                    
                </script>
            </head>
            <div className="services-name">
                <div className={`${stylePrem.back1} service-item`} ref={(el) => addToRefs(el, 0)}>
                    <h1>إقامة مستثمر أعمال</h1>
                    <div>
                        <span><Link to='/services/invbizres'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة مستثمر أعمال'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${stylePrem.back2} service-item`} ref={(el) => addToRefs(el, 1)}>
                    <h1>إقامة مميزة غير محددة المدة ومحددة المدة</h1>
                    <div>
                        <span><Link to='/services/unires'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة مميز'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${stylePrem.back3} service-item`} ref={(el) => addToRefs(el, 2)}>
                    <h1>إقامة رائدة أعمال</h1>
                    <div>
                        <span><Link to='/services/entres'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة رائد اعمال'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${stylePrem.back4} service-item`} ref={(el) => addToRefs(el, 3)}>
                    <h1>إقامة مالك عقار</h1>
                    <div>
                        <span><Link to='/services/proownres'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة مالك عقار'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${stylePrem.back5} service-item`} ref={(el) => addToRefs(el, 4)}>
                    <h1>إقامة الموهبة</h1>
                    <div>
                        <span><Link to='/services/talres'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة الموهبة'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${stylePrem.back6} service-item`} ref={(el) => addToRefs(el, 5)}>
                    <h1>إقامة الكفائة الاستثنائية</h1>
                    <div>
                        <span><Link to='/services/excepres'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة الكفائة الاستثنائية'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PremiumResidency